import { Pressable, Text as TextBase, View } from 'react-native';
import styled from 'styled-components/native';
import { mixins } from '~/theme/mixins';
import { HoverableProps } from '~/types/hoverable';

interface ButtonHoverableStyledProps extends HoverableProps {}

export const Container = styled(Pressable)<ButtonHoverableStyledProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 8px 8px 8px 16px;
    border-radius: 4px;
`;

export const IconContainer = styled(View)`
    margin-right: 16px;
`;

export const TextContent = styled(View)`
    flex: 1;
`;

export const Text = styled(TextBase)<{ color: string }>`
    ${mixins.typography.ui.medium14};
    color: ${({ color }) => color};
    margin-right: 20px;
`;
